import { API_URL } from 'app/constants/api.constant';
import axios, { AxiosInstance, CancelTokenSource } from 'axios';

interface Options {
  /**
   * The api version we want to use.
   */
  apiVersion?: string;
  /**
   * The full base url to use.
   * If it is defined, apiVersion and path will be ignored.
   * Can be useful when endpoints do not follow the standard api naming convention.
   */
  baseURL?: string;

  /** Token key params */
  tokenKey?: string;
  timeout?: number;
}

/**
 * Base Api class from which all other instances will extend.
 */
class BaseApi {
  api: AxiosInstance;

  baseURL: string;

  tokenKey: string;

  path: string | undefined;

  interceptorId: number[];

  /**
   * Stores a cancel token source for each request set as cancelable.
   * Requests are identified by a key generated using the URL and params.
   */
  axiosSourcesByRequestKey: Record<string, CancelTokenSource>;

  constructor({ baseURL = API_URL, timeout = 20000, tokenKey = 'token' }: Options) {
    this.interceptorId = [];

    this.api = axios.create({ baseURL, timeout });

    this.baseURL = baseURL;

    this.tokenKey = tokenKey;

    // this.api.interceptors.response.use((response) => response, this.onError);

    this.axiosSourcesByRequestKey = {};
  }

  setToken(token: string) {
    const { tokenKey } = this;
    const id = this.api.interceptors.request.use(function injectToken(config) {
      return {
        ...config,
        params: {
          ...config.params,
          [tokenKey]: token,
        },
      };
    });
    this.interceptorId.push(id);
  }

  removeToken() {
    this.interceptorId.forEach(interceptor => {
      axios.interceptors.request.eject(interceptor);
      this.api.interceptors.request.eject(interceptor);
    });
  }
}

export default BaseApi;
